import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const WarningIcon: React.FC<Props> = (props) => {
  return (
    <svg
      width="72"
      height="73"
      viewBox="0 0 72 73"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0 36.5C0 16.6178 16.1178 0.5 36 0.5C55.8823 0.5 72 16.6178 72 36.5C72 56.3823 55.8823 72.5 36 72.5C16.1178 72.5 0 56.3823 0 36.5Z"
        fill="url(#paint0_linear_34909_9334)"
      />
      <rect x="33" y="20.5" width="6" height="6" rx="2" fill="#DBA555" />
      <rect x="33" y="30.5" width="6" height="22" rx="2" fill="#DBA555" />
      <defs>
        <linearGradient
          id="paint0_linear_34909_9334"
          x1="36"
          y1="0.5"
          x2="36"
          y2="72.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFF6C7" />
          <stop offset="0.973958" stopColor="#FFE8AC" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default WarningIcon;
